import {useState} from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CarRentalForm from "./CarRentalForm";
import styles from "../showName/EditShowName.module.scss";

const EditCarRental = ({ carRental, setCarRental, onUpdate }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }


    return (
        <>
            <EditOutlinedIcon
                fontSize="small"
                onClick={handleOpen}
                className={`${styles.icon} m-1`}
            />
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle styles={`${styles.header} text-center`}>
                    Edit car rental
                </DialogTitle>
                <CarRentalForm
                    carRental={carRental}
                    setCarRental={setCarRental}
                    onCancel={handleClose}
                    onUpdate={onUpdate}
                />
            </Dialog>
        </>
    )
}

export default EditCarRental;
